export default "__VITE_ASSET__BNOoMKrO__"